import {
  React,
  Component,
  PropTypes,
} from 'imports/CommonImports';

import {
  PrimaryColor1,
  SuccessColorLight,
  GreyColor1,
  GreyColor2,
  ShadowColor,
} from 'imports/DesignImports';


import ReactHighcharts from 'react-highcharts';

import {
  Paper,
} from 'material-ui';


const styles = {
  pageContainer: {
    padding: '0px 25px'
  },
}

class SockGraph extends Component {
  constructor(props){
    super(props);
    this.state = {
      years: this.props.years,
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1, ShadowColor,],
    }
  }

  render() {
    return (
      <Paper style={{...styles.pageContainer, ...this.props.style}}>
        <p style={styles.header}><b>{this.props.header}</b></p>
        <ReactHighcharts config={this.config(this.state.extra)} ref="chart" style={{minHeight:"400px"}}></ReactHighcharts>
      </Paper>
    );
  }

  handleChange = (event, newValue, index) => {
    var extra = this.state.extra;
    extra[index] = parseInt(newValue, 10);
    this.setState({extra: extra});
  }

  config = (extra) => { return({
    chart: {
        type: 'column',
        backgroundColor: GreyColor2,
    },
    title: {
      text: '',
    },
    xAxis: {
        categories: this.state.years
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Porcentaje',
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (ReactHighcharts.theme && ReactHighcharts.theme.textColor) || 'gray'
            },
        },
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'percent',
            dataLabels: {
                enabled: true,
                color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white',
                formatter: function () {
                  var string = parseInt(this.percentage, 10) + '%';
                  return string;
                }
            },
            allowPointSelect: true,
            events: {
              legendItemClick: function () {
                  return false;
              }
          }
        },
    },
    series: this.props.data.map((data, i) => {return {name: data.option, data: data.values.map(value => value.value), color: this.state.colors[i]}}),
    credits: {
      enabled: false
    }
  })}
}

SockGraph.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array,
  header: PropTypes.string,
  indicator: PropTypes.string,
  currency: PropTypes.string,
};

SockGraph.defaultProps = {
  style: {},
  data: [{option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}, {option: 'N/A', values: [0,1,2]}],
  header: 'Sin datos',
  indicator: 'EBITDA',
  currency: 'CLP'
};

export default SockGraph;



// WEBPACK FOOTER //
// ./src/components/dashboard/SockGraph.js